export interface DataResultRaw<T> {
  /**
   * Array of items returned from the server.
   * @external
   */
  items: T[];
  /**
   * Total items available in the server, *after* applying filters. If not provided, offset pagination will not work correctly.
   * If you are using a cursor and did not include `total` in your query request, you can use the `fetchTotal` function to extract it asynchronously.
   * @default `items.length`
   * @external
   */
  total?: number | null;
  /**
   * Total items available in the server, *before* applying filters.
   * @external
   */
  available?: number;
  /**
   * In case of cursor pagination, this will be the value that will be sent in the query on the next page request.
   * @external
   */
  cursor?: string | undefined | null;
  /**
   * Indicates whether there are more items available after the current page.
   * @external
   */
  hasNext?: boolean | null;
}
